export function getQueryParamsFromHash() {
  const { hash } = window.location
  const queryString = hash.includes('?') ? hash.split('?')[1] : ''
  const searchParams = new URLSearchParams(queryString)
  const paramsObject = {}
  for (const [key, value] of searchParams.entries()) {
    paramsObject[key] = value
  }
  return paramsObject
}
